import {
  IScaleExperience,
  ITrainingExperience,
  IStudyCourse,
  ICourseScoresDetails,
  ICourseThresholds,
  ICourseAcceptableScore,
  IPersonnelAtSite,
  IPersonnelTrainingScoreDetail,
  ILookup
} from "../../model";
import { ISelectData } from "front-end-lib/core";
import { EXPERIENCE_STATUS_DISPLAY_VALUE } from "../../constants";

export const mockScaleExperienceData: IScaleExperience[] = [
  {
    userCourseStatusId: "100",
    scaleCourseId: 123,
    scaleName: "M.I.N.I.",
    experienceMonth: "",
    experienceYear: "",
    scaleUsage: "",
    status: EXPERIENCE_STATUS_DISPLAY_VALUE.INCOMPLETE,
    overrideStatus: "",
    statusDate: null,
    comment: null
  },
  {
    userCourseStatusId: "201",
    scaleCourseId: 124,
    scaleName: "MADRS",
    experienceMonth: "1",
    experienceYear: "6",
    scaleUsage: "6-10",
    status: EXPERIENCE_STATUS_DISPLAY_VALUE.QUESTIONABLE,
    overrideStatus: "",
    statusDate: "2017-12-15T00:00:00+00:00",
    comment: { commentId: "123abad", commentText: "Test comment" }
  },
  {
    userCourseStatusId: "303",
    scaleCourseId: 125,
    scaleName: "SCID",
    experienceMonth: "9",
    experienceYear: "4",
    scaleUsage: "20+",
    status: EXPERIENCE_STATUS_DISPLAY_VALUE.CLINICAL_REVIEW,
    overrideStatus: "",
    statusDate: "2019-06-23T00:00:00+00:00",
    comment: null
  }
];

export const mockScaleExperienceStatuses: ISelectData[] = [
  { label: "Eligible", value: "ELIGIBLE" },
  { label: "Questionable", value: "QUESTIONABLE" },
  { label: "Not Eligible", value: "NOTELIGIBLE" },
  { label: "Enriched Required", value: "ENRICHEDREQUIRED" },
  { label: "Co-Rating Required", value: "CORATINGREQUIRED" }
];

export const mockTrainingData: ITrainingExperience[] = [
  {
    userStudyQualificationStatusId: "00000000-0000-0000-0000-000000000000",
    studyQualificationId: "f072bc12-b48f-ea11-85b1-00155d0f1e6b",
    studyQualificationName: "CDR System Certification",
    studyQualificationStatus: null,
    studyQualificationStatusDate: null,
    comment: null,
    userLearningPlanStatuses: []
  },
  {
    userStudyQualificationStatusId: "0ABC0000-0000-0000-0000-000000000000",
    studyQualificationId: "0e7abc12-b48f-ea11-85b1-00155d0f1e6b",
    studyQualificationName: "CDR Scoring",
    studyQualificationStatus: { name: "Qualifiable", value: "QUALIFIABLE" },
    studyQualificationStatusDate: "2020-07-07T13:01:42.9256831+00:00",
    comment: null,
    userLearningPlanStatuses: [
      {
        userLearningPlanStatusId: "0000ZZZ0-0000-0000-0000-000000000000",
        learningPlanId: 57,
        legacyLearningPlanId: null,
        learningPlanName: "Testing Learning Plan with Scale Experience",
        learningPlanStatus: { name: "Qualifiable", value: "QUALIFIABLE" },
        learningPlanStatusDate: "2020-07-07T13:01:42.9256831+00:00",
        learningPlanAssignmentStatus: { name: "Assigned", value: "ASSIGNED" },
        isAssignable: false,
        userCourseStatuses: [
          {
            userCourseStatusId: "000GGG00-0000-0000-0000-000000000000",
            courseId: 141,
            studyComponentId: null,
            courseName: "Education Experience",
            courseStatus: { name: "Completed", value: "COMPLETED" },
            courseStatusDate: "2020-07-07T13:01:42.9256831+00:00",
            trainingCourseType: "SCORING",
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "000HHH00-0000-0000-0000-000000000000",
            courseId: 142,
            studyComponentId: null,
            courseName: "Clinical Experience",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "000LLL00-0000-0000-0000-000000000000",
            courseId: 160,
            studyComponentId: null,
            courseName: "Wildcard Questions",
            courseStatus: { name: "Exempt", value: "EXEMPT" },
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: true,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "00PPP000-0000-0000-0000-000000000000",
            courseId: 172,
            studyComponentId: null,
            courseName: "Updated Hidden Question Test",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: true,
            sourceEntry: ""
          }
        ]
      },
      {
        userLearningPlanStatusId: "00qwe000-0000-0000-0000-000000000000",
        legacyLearningPlanId: null,
        learningPlanId: 199,
        learningPlanName: "AAATesting Learning Plan2",
        learningPlanStatus: { name: "Incomplete", value: "INCOMPLETE" },
        learningPlanStatusDate: "",
        learningPlanAssignmentStatus: { name: "Assigned", value: "ASSIGNED" },
        isAssignable: true,
        userCourseStatuses: [
          {
            userCourseStatusId: "000TRR00-0000-0000-0000-000000000000",
            courseId: 241,
            studyComponentId: null,
            courseName: "Education Experience",
            courseStatus: { name: "Completed", value: "COMPLETED" },
            courseStatusDate: "2020-07-07T13:01:42.9256831+00:00",
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "000POI00-0000-0000-0000-000000000000",
            courseId: 1425,
            studyComponentId: null,
            courseName: "Clinical Experience",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "00ABC000-0000-0000-0000-000000000000",
            courseId: 1669,
            studyComponentId: null,
            courseName: "Wildcard Questions",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: true,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "00LKJ000-0000-0000-0000-000000000000",
            courseId: 173,
            studyComponentId: null,
            courseName: "Updated Hidden Question Test",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          }
        ]
      }
    ]
  },
  {
    userStudyQualificationStatusId: "ZABC0000-0000-0000-0000-000000000000",
    studyQualificationId: "0e7a9999-b48f-ea11-85b1-00155d0f1e6b",
    studyQualificationName: "CDR Scoring2",
    studyQualificationStatus: { name: "Qualifiable", value: "QUALIFIABLE" },
    studyQualificationStatusDate: "2020-07-07T13:01:42.9256831+00:00",
    comment: null,
    userLearningPlanStatuses: [
      {
        userLearningPlanStatusId: "00003210-0000-0000-0000-000000000000",
        learningPlanId: 59,
        legacyLearningPlanId: null,
        learningPlanName: "Testing Learning Plan with Scale Experience",
        learningPlanStatus: { name: "Qualifiable", value: "QUALIFIABLE" },
        learningPlanAssignmentStatus: { name: "Assigned", value: "ASSIGNED" },
        learningPlanStatusDate: "2020-07-07T13:01:42.9256831+00:00",
        isAssignable: false,
        userCourseStatuses: [
          {
            userCourseStatusId: "000GFG00-0000-0000-0000-000000000000",
            courseId: 146,
            studyComponentId: null,
            courseName: "Education Experience",
            courseStatus: { name: "Completed", value: "COMPLETED" },
            courseStatusDate: "2020-07-07T13:01:42.9256831+00:00",
            trainingCourseType: "Scoring",
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: true,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "000HHH00-0000-0000-0000-000000000000",
            courseId: 143,
            studyComponentId: null,
            courseName: "Clinical Experience",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "000LLL00-0000-0000-0000-000000000000",
            courseId: 166,
            studyComponentId: null,
            courseName: "Wildcard Questions",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "00PPP000-0000-0000-0000-000000000000",
            courseId: 192,
            studyComponentId: null,
            courseName: "Updated Hidden Question Test",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          }
        ]
      },
      {
        userLearningPlanStatusId: "0KJD000-0000-0000-0000-000000000000",
        learningPlanId: 99,
        legacyLearningPlanId: null,
        learningPlanName: "AAATesting Learning Plan2",
        learningPlanStatus: { name: "Incomplete", value: "INCOMPLETE" },
        learningPlanStatusDate: "",
        learningPlanAssignmentStatus: null,
        isAssignable: true,
        userCourseStatuses: [
          {
            userCourseStatusId: "000TRR00-0000-0000-0000-000000000000",
            courseId: 141,
            studyComponentId: null,
            courseName: "Education Experience",
            courseStatus: { name: "Completed", value: "COMPLETED" },
            courseStatusDate: "2020-07-07T13:01:42.9256831+00:00",
            trainingCourseType: "Scoring",
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "000POI00-0000-0000-0000-000000000000",
            courseId: 1427,
            studyComponentId: null,
            courseName: "Clinical Experience",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "00ABC000-0000-0000-0000-000000000000",
            courseId: 188,
            studyComponentId: null,
            courseName: "Wildcard Questions",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: true,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "00LKJ000-0000-0000-0000-000000000000",
            courseId: 174,
            studyComponentId: null,
            courseName: "Updated Hidden Question Test",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          }
        ]
      }
    ]
  },
  {
    userStudyQualificationStatusId: "ZABC0099-0000-0000-0000-000000999900",
    studyQualificationId: "0e7a9999-b48f-ea11-85b1-00155d0fzzzz",
    studyQualificationName: "Legacy CDR Scoring2",
    studyQualificationStatus: { name: "Qualifiable", value: "QUALIFIABLE" },
    studyQualificationStatusDate: "2020-09-07T13:01:42.9256831+00:00",
    comment: null,
    userLearningPlanStatuses: [
      {
        userLearningPlanStatusId: "0KJD000-0000-0000-0000-000000000000",
        learningPlanId: 0,
        legacyLearningPlanId: "1234-3333",
        learningPlanName: "Legacy AAATesting Learning Plan2",
        learningPlanStatus: { name: "Incomplete", value: "INCOMPLETE" },
        learningPlanStatusDate: "",
        learningPlanAssignmentStatus: null,
        isAssignable: false,
        userCourseStatuses: [
          {
            userCourseStatusId: "000TRR00-0999-0000-0000-000000000000",
            courseId: null,
            studyComponentId: "1233-5555-2222",
            courseName: "Education Experience",
            courseStatus: { name: "Completed", value: "COMPLETED" },
            courseStatusDate: "2020-07-07T13:01:42.9256831+00:00",
            trainingCourseType: "Scoring",
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "000POI00-0000-0000-0000-00000zzz0000",
            courseId: null,
            studyComponentId: "1233-5555-4444",
            courseName: "Clinical Experience",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "00ABC000-0000-0000-0000-000000000000",
            courseId: null,
            studyComponentId: "1233-5555-5432",
            courseName: "Wildcard Questions",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          },
          {
            userCourseStatusId: "00LKJ000-0000-0000-0000-000000000000",
            courseId: null,
            studyComponentId: "1233-5555-3383",
            courseName: "Updated Hidden Question Test",
            courseStatus: null,
            courseStatusDate: null,
            trainingCourseType: null,
            comment: null,
            canOverride: false,
            isEligibleForManualDataEntry: false,
            sourceEntry: ""
          }
        ]
      }
    ]
  }
];

export const mockStudyData = [
  {
    demographic: "Adult",
    indication: "Autism",
    internalStudyName: "internal1",
    protocol: "protocol1",
    scale: null,
    sponsorId: "1",
    sponsorName: "sponsor1",
    studyId: "1",
    studyName: "study1",
    therapeuticArea: "Neurology"
  },
  {
    demographic: "Pediatric",
    indication: "Cardiovascular",
    internalStudyName: "internal2",
    protocol: "protocol2",
    scale: null,
    sponsorId: "2",
    sponsorName: "sponsor2",
    studyId: "2",
    studyName: "study2",
    therapeuticArea: "Psychiatry"
  },
  {
    demographic: "Pediatric",
    indication: "Sleep Disorders",
    internalStudyName: "internal3",
    protocol: "protocol3",
    scale: null,
    sponsorId: "3",
    sponsorName: "sponsor3",
    studyId: "3",
    studyName: "study3",
    therapeuticArea: "Psychiatry"
  }
];

export const mockCourseData: IStudyCourse[] = [
  {
    courseName: "Clinical Experience",
    learningPlanName: "Testing Learning Plan",
    studyQualificationName: "CDR Scoring",
    courseId: 141,
    studyComponentId: null
  },
  {
    courseName: "Placebo Response Training",
    learningPlanName: "MADRS training plan",
    studyQualificationName: "MADRS Qualification",
    courseId: 142,
    studyComponentId: null
  },
  {
    courseName: "Wildcard Questions",
    learningPlanName: "Testing Learning Plan",
    studyQualificationName: "CDR Scoring",
    courseId: 160,
    studyComponentId: null
  },
  {
    courseName: "Legacy Course",
    learningPlanName: "Legacy Learning Plan",
    studyQualificationName: "Legacy Scoring",
    courseId: null,
    studyComponentId: "123"
  }
];

export const mockCourseThresholds: ICourseThresholds[] = [
  {
    passingThresholdPercentage: 85,
    remediationThresholdPercentage: 65,
    isLocked: false
  },
  {
    passingThresholdPercentage: 85,
    remediationThresholdPercentage: 65,
    isLocked: true
  },
  {
    passingThresholdPercentage: 85,
    remediationThresholdPercentage: 65,
    isLocked: true
  },
  {
    passingThresholdPercentage: 85,
    remediationThresholdPercentage: 65,
    isLocked: true
  }
];

export const mockCountryScores: ICourseScoresDetails[] = [
  {
    courseName: "Test Course",
    masterAcceptableScore: {
      masterAcceptableScoreId: null,
      isLocked: false
    },
    countryAcceptableScores: [
      {
        countryName: "Canada",
        hasCountrySpecificScoreSheet: true,
        countryAcceptableScoreId: "333",
        countryId: "1"
      },
      {
        countryName: "Mexico",
        hasCountrySpecificScoreSheet: true,
        countryAcceptableScoreId: "875",
        countryId: "2"
      },
      {
        countryName: "United States",
        hasCountrySpecificScoreSheet: false,
        countryAcceptableScoreId: "123",
        countryId: "3"
      }
    ]
  },
  {
    courseName: "Test Course2",
    masterAcceptableScore: {
      masterAcceptableScoreId: null,
      isLocked: false
    },
    countryAcceptableScores: [
      {
        countryName: "Canada",
        hasCountrySpecificScoreSheet: true,
        countryAcceptableScoreId: "333",
        countryId: "1"
      },
      {
        countryName: "Mexico",
        hasCountrySpecificScoreSheet: true,
        countryAcceptableScoreId: "875",
        countryId: "2"
      },
      {
        countryName: "United States",
        hasCountrySpecificScoreSheet: false,
        countryAcceptableScoreId: "123",
        countryId: "3"
      }
    ]
  },
  {
    courseName: "Test Course3",
    masterAcceptableScore: {
      masterAcceptableScoreId: "1",
      isLocked: false
    },
    countryAcceptableScores: [
      {
        countryName: "Canada",
        hasCountrySpecificScoreSheet: true,
        countryAcceptableScoreId: "333",
        countryId: "1"
      },
      {
        countryName: "Mexico",
        hasCountrySpecificScoreSheet: true,
        countryAcceptableScoreId: "875",
        countryId: "2"
      },
      {
        countryName: "United States",
        hasCountrySpecificScoreSheet: false,
        countryAcceptableScoreId: "123",
        countryId: "3"
      }
    ]
  },
  {
    courseName: "Test Course4",
    masterAcceptableScore: {
      masterAcceptableScoreId: "1",
      isLocked: true
    },
    countryAcceptableScores: [
      {
        countryName: "Canada",
        hasCountrySpecificScoreSheet: true,
        countryAcceptableScoreId: "333",
        countryId: "1"
      },
      {
        countryName: "Mexico",
        hasCountrySpecificScoreSheet: true,
        countryAcceptableScoreId: "875",
        countryId: "2"
      },
      {
        countryName: "United States",
        hasCountrySpecificScoreSheet: false,
        countryAcceptableScoreId: "123",
        countryId: "3"
      }
    ]
  },
  {
    courseName: "Test Course5",
    masterAcceptableScore: {
      masterAcceptableScoreId: "1",
      isLocked: false
    },
    countryAcceptableScores: [
      {
        countryName: "Canada",
        hasCountrySpecificScoreSheet: true,
        countryAcceptableScoreId: "333",
        countryId: "1"
      },
      {
        countryName: "Mexico",
        hasCountrySpecificScoreSheet: true,
        countryAcceptableScoreId: "875",
        countryId: "2"
      },
      {
        countryName: "United States",
        hasCountrySpecificScoreSheet: false,
        countryAcceptableScoreId: "123",
        countryId: "3"
      }
    ]
  }
];

export const mockMasterScoresData: ICourseAcceptableScore[][] = [
  [
    {
      courseQuestionId: "1",
      courseQuestionText: "Question 1",
      acceptableResponse: null,
      answerSet: "1,2,3"
    },
    {
      courseQuestionId: "2",
      courseQuestionText: "Question 2",
      acceptableResponse: null,
      answerSet: "1,2,3,5"
    },
    {
      courseQuestionId: "3",
      courseQuestionText: "Question 3",
      acceptableResponse: null,
      answerSet: "1,2"
    }
  ],
  [
    {
      courseQuestionId: "1",
      courseQuestionText: "Question 1",
      acceptableResponse: null,
      answerSet: "0,1,2,3"
    },
    {
      courseQuestionId: "2",
      courseQuestionText: "Question 2",
      acceptableResponse: null,
      answerSet: "1,2,3"
    },
    {
      courseQuestionId: "3",
      courseQuestionText: "Question 3",
      acceptableResponse: null,
      answerSet: "5-7"
    }
  ],
  [
    {
      courseQuestionId: "1",
      courseQuestionText: "Question 1",
      acceptableResponse: null,
      answerSet: "1.1,1.2,1.3"
    },
    {
      courseQuestionId: "2",
      courseQuestionText: "Question 2",
      acceptableResponse: null,
      answerSet: "1,2,3,10"
    },
    {
      courseQuestionId: "3",
      courseQuestionText: "Question 3",
      acceptableResponse: null,
      answerSet: "1,2,3"
    }
  ],
  [
    {
      courseQuestionId: "1",
      courseQuestionText: "Question 1",
      acceptableResponse: "1-3",
      answerSet: "1,2,3"
    },
    {
      courseQuestionId: "2",
      courseQuestionText: "Question 2",
      acceptableResponse: "3-5,6",
      answerSet: "1,2,3,4,5,6"
    },
    {
      courseQuestionId: "3",
      courseQuestionText: "Question 3",
      acceptableResponse: "7",
      answerSet: "1,2,3-10"
    }
  ],
  [
    {
      courseQuestionId: "Q1",
      courseQuestionText: "Question 1",
      acceptableResponse: "1-3",
      answerSet: "1,2,3,4-6"
    },
    {
      courseQuestionId: "Q2",
      courseQuestionText: "Question 2",
      acceptableResponse: "3-5,6",
      answerSet: "1,3"
    },
    {
      courseQuestionId: "Q3",
      courseQuestionText: "Question 3",
      acceptableResponse: "7",
      answerSet: "1,2"
    }
  ],
  [
    // empty response and answer set used to test create
    {
      courseQuestionId: "Q1",
      courseQuestionText: "Question 1",
      acceptableResponse: "",
      answerSet: ""
    },
    {
      courseQuestionId: "Q2",
      courseQuestionText: "Question 2",
      acceptableResponse: "",
      answerSet: ""
    },
    {
      courseQuestionId: "Q3",
      courseQuestionText: "Question 3",
      acceptableResponse: "",
      answerSet: ""
    }
  ]
];

export const mockCountryScoresData: ICourseAcceptableScore[][] = [
  [
    {
      courseQuestionId: "1",
      courseQuestionText: "Question 1",
      acceptableResponse: null
    },
    {
      courseQuestionId: "2",
      courseQuestionText: "Question 2",
      acceptableResponse: null
    },
    {
      courseQuestionId: "3",
      courseQuestionText: "Question 3",
      acceptableResponse: null
    }
  ],
  [
    {
      courseQuestionId: "1",
      courseQuestionText: "Question 1",
      acceptableResponse: null
    },
    {
      courseQuestionId: "2",
      courseQuestionText: "Question 2",
      acceptableResponse: null
    },
    {
      courseQuestionId: "3",
      courseQuestionText: "Question 3",
      acceptableResponse: null
    }
  ],
  [
    {
      courseQuestionId: "1",
      courseQuestionText: "Question 1",
      acceptableResponse: null
    },
    {
      courseQuestionId: "2",
      courseQuestionText: "Question 2",
      acceptableResponse: null
    },
    {
      courseQuestionId: "3",
      courseQuestionText: "Question 3",
      acceptableResponse: null
    }
  ],
  [
    {
      courseQuestionId: "1",
      courseQuestionText: "Question 1",
      acceptableResponse: "1-4"
    },
    {
      courseQuestionId: "2",
      courseQuestionText: "Question 2",
      acceptableResponse: "3-5"
    },
    {
      courseQuestionId: "3",
      courseQuestionText: "Question 3",
      acceptableResponse: "8"
    }
  ],
  [
    {
      courseQuestionId: "Q1",
      courseQuestionText: "Question 1",
      acceptableResponse: "2-4"
    },
    {
      courseQuestionId: "Q2",
      courseQuestionText: "Question 2",
      acceptableResponse: "3-5"
    },
    {
      courseQuestionId: "Q3",
      courseQuestionText: "Question 3",
      acceptableResponse: "7"
    }
  ]
];

export const mockPersonnelAtSite: IPersonnelAtSite[] = [
  {
    personnelId: "b0d6a181-e99b-4071-18a5-08d819155887",
    userName: "Bob.Jones",
    type: "Internal",
    firstName: "Bob",
    lastName: "Jones",
    email: "Bob.Jones@bracketglobal.com",
    existsInCurrentStudySite: true,
    roles: []
  },
  {
    personnelId: "93c22279-43af-ea11-947d-00155d0f1e6b",
    userName: "John.Smith",
    type: "External",
    firstName: "John",
    lastName: "Smith",
    email: "john.smith@somewhere.com",
    existsInCurrentStudySite: false,
    roles: []
  },
  {
    personnelId: "93c22279-43af-ea11-947d-00155dxx1e6b",
    userName: "Jim.Tran",
    type: "External",
    firstName: "Jim",
    lastName: "Tran",
    email: "jim.tran@somewhere.com",
    existsInCurrentStudySite: false,
    roles: []
  }
];

export const mockSearchUserData = [
  {
    firstName: "Visalakshi",
    lastName: "Mandavilli",
    userName: "v.mandavilli",
    type: "External",
    email: "v.mandavilli@somewhere.com"
  },
  {
    firstName: "Sallyanne",
    lastName: "Brockway",
    userName: "Sallyanne.Brockway",
    type: "Internal",
    email: "Sallyanne.Brockway@somewhere.com"
  },
  {
    firstName: "Saleem",
    lastName: "Ismail",
    userName: "saleem.ismail",
    type: "Internal",
    email: "saleem.ismail@somewhere.com"
  },
  {
    firstName: "Salini",
    lastName: "Makineni",
    userName: "salini.makineni",
    type: "External",
    email: "salini.makineni@bracketglobal.com"
  }
];

export const mockBulkLPAssignData = [
  {
    countryName: "United States",
    sponsorSiteId: "123",
    personnelName: "John Smith",
    personnelId: "123",
    isAssigned: false,
    roles: [{ name: "Principal Investigator", roleId: "123" }]
  },
  {
    countryName: "Mexico",
    sponsorSiteId: "333",
    personnelName: "Bob Jones",
    personnelId: "333",
    isAssigned: false,
    roles: [{ name: "Rater", roleId: "333" }]
  },
  {
    countryName: "Grenada",
    sponsorSiteId: "433",
    personnelName: "Sal Miller",
    personnelId: "623",
    isAssigned: true,
    roles: [
      { name: "Rater", roleId: "333" },
      { name: "Principal Investigator", roleId: "123" }
    ]
  }
];

export const mockBulkLPs = [
  { id: 1, name: "LP #1" },
  { id: 2, name: "LP #2" },
  { id: 3, name: "LP #3" }
];

export const mockPersonnelTrainingScores: IPersonnelTrainingScoreDetail = {
  absoluteItemsDeviation: 7,
  courseName: "Test Course Name",
  courseStatus: { name: "Fail", value: "FAIL" },
  itemsDeviation: 3,
  overallPercentage: 60,
  statusDate: "2020-11-16T18:39:17+00:00",
  totalScore: 62,
  modifiedBy: "test.user",
  modifiedDate: "2018-07-13T10:39:19.953+00:00",
  qcDate: undefined,
  qcUser: undefined,
  sourceEntry: undefined,
  courseCompletionDate: undefined,
  questionAnswers: [
    {
      courseQuestionId: "1",
      courseQuestionText: "Question 1",
      acceptableResponse: "3-5",
      isResponseCorrect: true,
      userResponse: "4"
    },
    {
      courseQuestionId: "2",
      courseQuestionText: "Question 2",
      acceptableResponse: "2",
      isResponseCorrect: false,
      userResponse: "6"
    },
    {
      courseQuestionId: "3",
      courseQuestionText: "Question 3",
      acceptableResponse: "2,3,5",
      isResponseCorrect: true,
      userResponse: "3"
    },
    {
      courseQuestionId: "4",
      courseQuestionText: "Question 4",
      acceptableResponse: "8",
      isResponseCorrect: false,
      userResponse: "7"
    },
    {
      courseQuestionId: "5",
      courseQuestionText: "Question 5",
      acceptableResponse: "1-2,4",
      isResponseCorrect: true,
      userResponse: "1"
    }
  ]
};

export const mockTrainingCourseScores = {
  courseCompletionDate: "2022-08-25T00:00:00+00:00",
  modifiedDate: "2022-08-25T14:00:17.5177186-05:00",
  questionAnswers: [
    {
      courseQuestionText: "Question 1",
      acceptableResponse: "3-5",
      userResponse: "4"
    },
    {
      courseQuestionText: "Question 2",
      acceptableResponse: "2",
      userResponse: "6"
    },
    {
      courseQuestionText: "Question 3",
      acceptableResponse: "2,3,5",
      userResponse: "3"
    },
    {
      courseQuestionText: "Question 4",
      acceptableResponse: "8",
      userResponse: "7"
    },
    {
      courseQuestionText: "Question 5",
      acceptableResponse: "1-2,4",
      userResponse: "1"
    }
  ]
};

export const mockDemographics: ILookup[] = [
  {
    value: "572ca0c8-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Adolescent"
  },
  {
    value: "582ca0c8-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Adult"
  },
  {
    value: "592ca0c8-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Geriatric"
  },
  {
    value: "562ca0c8-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Pediatric"
  }
];

export const mockIndications: ILookup[] = [
  {
    value: "2cd82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Acne"
  },
  {
    value: "2dd82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Acute Bacterial Skin and Skin Structure Infections"
  },
  {
    value: "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Acute Coronary Syndrome"
  },
  {
    value: "80d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Acute Hypoxemic Respiratory Failure"
  },
  {
    value: "add82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Acute Ischemic Stroke"
  },
  {
    value: "bed82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Acute Spinal Cord Injury"
  },
  {
    value: "06d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Addiction"
  },
  {
    value: "60d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Adenocarcinoma"
  },
  {
    value: "dcd72ae0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Alcohol Dependence"
  },
  {
    value: "4ed82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Allergy"
  },
  {
    value: "11d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Amyotrophic Lateral Sclerosis"
  }
];

export const mockSpecialties = [
  {
    value: "d794cbe7-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "ADHD"
  },
  {
    value: "f294cbe7-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Age Associated Memory Impairment (new)"
  },
  {
    value: "d194cbe7-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Alcohol"
  },
  {
    value: "da94cbe7-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Alzheimer's Disease"
  },
  {
    value: "df94cbe7-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Behavioral Disturbance"
  }
];

export const mockTherapeuticAreas = [
  {
    value: "bc1e5ed0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Cardiovascular"
  },
  {
    value: "b31e5ed0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Chronic Pain"
  },
  {
    value: "bb1e5ed0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Cognition"
  },
  {
    value: "c11e5ed0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Dental"
  },
  {
    value: "b61e5ed0-4c0f-eb11-9ab7-000d3a1ad69f",
    label: "Dermatology"
  }
];

export const mockPersonData = {
  id: "b15d26a0-a917-eb11-9ab8-000d3a1ad69f",
  firstName: "Van",
  lastName: "Johnson",
  userName: "Van.Johnson",
  type: "External",
  email: "test.user@signanthealth.com",
  raterId: 122290,
  personnelContactInfo: {
    phone: "610-999-1234",
    mobilePhone: "999-222-1111",
    fax: "888-333-1231",
    emailAddress2: "email2@test.com",
    emailAddress3: "email3@test.com"
  },
  studyHistory: [
    {
      sponsorName: "ad1030",
      studyId: "2a5bb0ba-393b-425c-5b76-08d89ae17648",
      studyName: "CASTestStudy",
      internalStudyName: "CASTestStudy",
      protocols: [
        {
          id: "26ab55f7-9b94-4ae1-a7d2-08d89ae19018",
          protocolName: "Protocol 1"
        },
        {
          id: "46186eaf-e891-4ee1-a7d3-08d89ae19018",
          protocolName: "Protocol 2"
        }
      ],
      site: {
        id: "77cb2d64-4d0f-eb11-9ab7-000d3a1ad69f",
        name: "1 Jianshe East Road"
      }
    },
    {
      sponsorName: "RG Smoke Test",
      studyId: "c87d5237-2be5-4969-dc89-08d88065123c",
      studyName: "PI Status Logic Test Study",
      internalStudyName: "StatusLogic1",
      protocols: [
        {
          id: "86f1e9bc-809d-4746-aef0-08d8806567a6",
          protocolName: "SLTS 01"
        }
      ],
      site: {
        id: "26cc2d64-4d0f-eb11-9ab7-000d3a1ad69f",
        name: "Chrysalis Clinical Research"
      }
    },
    {
      sponsorName: "sponsor 100",
      studyId: "598c42a4-da1a-4da6-1c2e-08d877893e85",
      studyName: "Testing Study 09182020",
      internalStudyName: "12TES200918",
      protocols: [
        {
          id: "4bef4d5b-556c-4d8d-9851-08d87789ad25",
          protocolName: "Protocol 1"
        },
        {
          id: "d1bb3c74-9f08-48ea-068b-08d87a994751",
          protocolName: "Protocol 2"
        }
      ],
      site: {
        id: "26cc2d64-4d0f-eb11-9ab7-000d3a1ad69f",
        name: " Chrysalis Clinical Research"
      }
    },
    {
      sponsorName: "sponsor 205",
      studyId: "268988e9-4d0f-eb11-9ab7-000d3a1ad69f",
      studyName: "RDA Test Study 1105",
      internalStudyName: "12RDATS1105",
      protocols: [
        {
          id: "4cb7443d-be17-eb11-9ab8-000d3a1ad69f",
          protocolName: "Protocol 1"
        }
      ],
      site: {
        id: "2b021d64-4d0f-eb11-9ab7-000d3a1ad69f",
        name: "Atlanta Center for Medical Research"
      }
    }
  ]
};

export const mockPersonnel = [
  {
    id: "5e9877cc-570f-eb11-9ab8-000d3a1ad69f",
    firstName: "Sanjith",
    lastName: "Aaron",
    userName: "Sanjith.Aaron",
    type: "External",
    email: "Sanjith.Aaron@test.com",
    raterId: 23985
  },
  {
    id: "393d8dc3-570f-eb11-9ab8-000d3a1ad69f",
    firstName: "Casey",
    lastName: "Aaron",
    userName: "casey.aaron",
    type: "External",
    email: "casey.aaron@this.com",
    raterId: 58850
  },
  {
    id: "7b4a8dc3-570f-eb11-9ab8-000d3a1ad69f",
    firstName: "Elizabeth ",
    lastName: "Aaron",
    userName: "Elizabeth.Aaron",
    type: "External",
    email: "Elizabeth.Aaron@somewhere.com",
    raterId: 103225
  },
  {
    id: "4cc3a2c3-570f-eb11-9ab8-000d3a1ad69f",
    firstName: "Scott",
    lastName: "Aaronson",
    userName: "Scott.Aaronson",
    type: "External",
    email: "Scott.Aaronson@happyplace.com",
    raterId: 1063
  }
];

export const mockPersonnelExperienceWithoutAnswers = {
  general: [
    {
      name: "Country of Residence",
      meta: [],
      questions: ["Country"],
      answers: []
    },
    {
      name: "Languages",
      meta: [],
      questions: ["Proficiency", "Language"],
      answers: []
    }
  ],
  education: [
    {
      name: "Degree",
      meta: [],
      questions: [],
      answers: []
    },
    {
      name: "Board Certification",
      meta: [],
      questions: ["Board certified"],
      answers: []
    },
    {
      name: "License",
      meta: [],
      questions: ["Licensed"],
      answers: []
    }
  ],
  experienceGeneral: [
    {
      name: "Experience (General)",
      meta: ["isActive", "demographicId"],
      questions: [
        "Type",
        "Experience (Y/N)",
        "Clinical Experience (Years)",
        "Clinical Experience (Months)",
        "Clinical Trial Experience (Years)",
        "Clinical Trial Experience (Months)",
        "Number of Clinical Trials"
      ],
      answers: []
    }
  ],
  experienceIndications: [
    {
      name: "Experience (Indication)",
      meta: ["isActive", "indicationId", "demographicId"],
      questions: [
        "Indication",
        "Experience (Y/N)",
        "Clinical Experience (Years)",
        "Clinical Experience (Months)",
        "Clinical Trial Experience (Years)",
        "Clinical Trial Experience (Months)",
        "Number of Clinical Trials"
      ],
      answers: []
    }
  ],
  experienceScales: [
    {
      name: "Scale Experience",
      meta: ["isActive", "scaleId"],
      questions: [
        "Scale",
        "Experience (Y/N)",
        "Administering (Years)",
        "Administering (Months)",
        "Past 12 Months (# Administrations)",
        "Past 24 Months (# Administrations)",
        "Lifetime (# Administrations)"
      ],
      answers: []
    }
  ]
};

export const mockPersonnelExperience = {
  general: [
    {
      name: "Country of Residence",
      meta: [],
      questions: ["Country"],
      answers: [["New Zealand"]]
    },
    {
      name: "Languages",
      meta: [],
      questions: ["Proficiency", "Language"],
      answers: [["en_NZ", "Native/Bilingual proficiency"]]
    }
  ],
  education: [
    {
      name: "Degree",
      meta: [],
      questions: ["Degree", "Specialty", "Country"],
      answers: [
        ["Ph.D.", "Sleep", "Austria"],
        ["M.D.", "Bipolar Disorder", "New Zealand"]
      ]
    },
    {
      name: "Board Certification",
      meta: [],
      questions: ["Board certified", "Area of Board Certification"],
      answers: [
        ["Yes", null],
        [null, "Child and Adolescent Psychiatry"],
        [null, "Addiction Psychology"]
      ]
    },
    {
      name: "License",
      meta: [],
      questions: ["Licensed", "Area of License"],
      answers: [
        ["Yes", null],
        [null, "Other Assistant"],
        [null, "AA (Anesthesiologist Assistant)"]
      ]
    }
  ],
  experienceGeneral: [
    {
      name: "Experience (General)",
      meta: ["isActive", "demographicId"],
      questions: [
        "Type",
        "Experience (Y/N)",
        "Clinical Experience (Years)",
        "Clinical Experience (Months)",
        "Clinical Trial Experience (Years)",
        "Clinical Trial Experience (Months)",
        "Number of Clinical Trials"
      ],
      answers: [
        [
          "Adolescent",
          null,
          null,
          null,
          null,
          null,
          null,
          true,
          "572ca0c8-4c0f-eb11-9ab7-000d3a1ad69f"
        ],
        [
          "Adult",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "582ca0c8-4c0f-eb11-9ab7-000d3a1ad69f"
        ]
      ]
    }
  ],
  experienceIndications: [
    {
      name: "Experience (Indication)",
      meta: ["isActive", "indicationId", "demographicId"],
      questions: [
        "Indication",
        "Experience (Y/N)",
        "Clinical Experience (Years)",
        "Clinical Experience (Months)",
        "Clinical Trial Experience (Years)",
        "Clinical Trial Experience (Months)",
        "Number of Clinical Trials"
      ],
      answers: [
        [
          "Acne",
          "Yes",
          "2 years",
          "24 months",
          "Less than 1 year",
          "10 months",
          "2",
          true,
          "2cd82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Acne Adolescent",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "2cd82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          "572ca0c8-4c0f-eb11-9ab7-000d3a1ad69f"
        ],
        [
          "Acute Coronary Syndrome",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Acute Coronary Syndrome Adolescent",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          "572ca0c8-4c0f-eb11-9ab7-000d3a1ad69f"
        ],
        [
          "Test5",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test6",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test7",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test8",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test9",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test10",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test11",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test12",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test13",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test14",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test15",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test16",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test17",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test18",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test19",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test20",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test21",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test22",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ],
        [
          "Test23",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "21d82ae0-4c0f-eb11-9ab7-000d3a1ad69f",
          null
        ]
      ]
    }
  ],
  experienceScales: [
    {
      name: "Scale Experience",
      meta: ["isActive", "scaleId"],
      questions: [
        "Scale",
        "Experience (Y/N)",
        "Administering (Years)",
        "Administering (Months)",
        "Past 12 Months (# Administrations)",
        "Past 24 Months (# Administrations)",
        "Lifetime (# Administrations)"
      ],
      answers: [
        [
          "{{MaxLengthShortNameAdd}}",
          "No",
          "4 years",
          "20",
          "31-50",
          "51+",
          "51+",
          true,
          "c8702a55-5d5e-46b7-c1d0-08d89580da89"
        ],
        [
          "{{ShortName_1_rStudyScale}}",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale3",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale4",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale5",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale6",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale7",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale8",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale9",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale10",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale11",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale12",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale13",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale14",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale15",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale16",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale17",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale18",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale19",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale20",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale21",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ],
        [
          "Scale22",
          null,
          null,
          null,
          null,
          null,
          null,
          false,
          "04174d28-7e0c-4557-c841-08d87c1d6289"
        ]
      ]
    }
  ]
};

// Mock data for study site personnel tests in API format
// IMPORTANT: The roleIds used here MUST match those defined in the mock roles data in src/sagas/lookupSaga.ts (notably, the PI roleId)
export const mockStudySitePersonnelAPIData = [
  {
    // NOTE: intentionally not using email as the userName for the mock data so that the test
    // can more easily verify the two different values
    personnelId: "person1",
    userName: "doe.john",
    type: "External",
    firstName: "John",
    lastName: "Doe",
    email: "john.doe@example.com",
    existsInCurrentStudySite: true,
    roles: [
      {
        roleId: "de88796f-f83d-ea11-8c6e-00155d0f1e6b", // Rater role from lookupSaga.ts
        name: "Rater"
      }
    ],
    isActive: true
  },
  {
    personnelId: "person2",
    userName: "smith.jane",
    type: "External",
    firstName: "Jane",
    lastName: "Smith",
    email: "jane.smith@example.com",
    existsInCurrentStudySite: true,
    roles: [
      {
        roleId: "df88796f-f83d-ea11-8c6e-00155d0f1e6b", // Principal Investigator role from lookupSaga.ts
        name: "Principal Investigator"
      },
      {
        roleId: "de88796f-f83d-ea11-8c6e-00155d0f1e6b", // Rater role from lookupSaga.ts
        name: "Rater"
      }
    ],
    isActive: true
  },
  {
    personnelId: "person3",
    userName: "johnson.bob",
    type: "External",
    firstName: "Bob",
    lastName: "Johnson",
    email: "bob.johnson@example.com",
    existsInCurrentStudySite: true,
    roles: [
      {
        roleId: "dd88796f-f83d-ea11-8c6e-00155d0f1e6b", // Study Coord. role from lookupSaga.ts
        name: "Study Coord."
      }
    ],
    isActive: false
  }
];
